import axios from "axios";
import apiURI from "./Api";

export default class AdminService {
  async getAreaManagers(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getareamanager/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getBusinessPartners(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getbusinesspartner/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getSpecialCustomers(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getspecialcustomer/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getSalePromoter(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getsalepromoter/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getSellers(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getseller/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getAllWithdrawRequests(token, adminUsername) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/withdraw/listall/${adminUsername}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getBangoodRequests(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getorders/banggood`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postProcessBangood(token, idOrder) {
    const bodyJson = {
      idorder: idOrder,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/admin/processorder/banggood`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postProcessWithdraw(token, withdrawId, adminUsername) {
    const bodyJson = {
      idwithdraw: withdrawId,
      useradmin: { username: adminUsername },
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/withdraw/process`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getAllOrders(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getorders/all`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postBlockOrUnblockUser(token, adminUsername, username, block) {
    const bodyJson = {
      admin: { username: adminUsername },
      userToBlockUnblock: { username: username },
      block: block,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/admin/blockunblockuser`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getPaidSubscriptions(token, paymentmethodid) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getpaidsubscriptions/${paymentmethodid}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getPendingOrders(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/getpendingorders`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async confirmOrderBankTransfer(token, admin, idorder) {
    const bodyJson = {
      admin: admin,
      idorder: idorder,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/admin/confirmorderbanktransfer`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }
}
